export default {
  //booked information
  book: {
    status: "Booking",
    interviewTitle: "Interview Date",
    NoteTitle: "Note",
    manageTitle: "Manage Booking",
    manageDate: "Select Date",
    manageTime: "Select Time",
  },

  //personal information
  info: {
    title: "Personal",
    birthdate: "Birthdate",
    gender: "Sex",
    address: "Address",
    ethnicity: "Ethnicity",
    nationality: "Nationality",
    religion: "Religion",
    maritalStatus: "Marital Status",
    militaryStatus: "Military status ",
    disabled: "Disabled",
    phone: "Phone Number",
    email: "Email",
    lastUpdated: "Last signed in",
  },

  // user resume
  resume: {
    title: "Resume",
    validText: "Valid",
    invalidText: "Invalid",
  },

  // Job preference
  jobPre: {
    title: "Job Preference",
    BusinessTitle: "Business",
    jobType: "Category",
    businessSector: "Type",
    empType: "Employment Type",
    jobPosition: "Position",
    expectedSalary: "Expected Salary",
    startDate: "Earliest Start Date",
    workLocation: "Preferred Work Location",
    workingStyles: "Job Function",
  },

  // education
  edu: {
    title: "Educational qualifications",
    institution: "Institution",
    schoolName: "School Name",
    schoolMajor: "Academic Track",
    grade: "Grade",
    universityName: "University Name",
    degree: "Degree",
    faculty: "Faculty",
    major: "Major",
    startDate: "Start date",
    endDate: "End date",
    gpa: "GPA",
  },

  //Work Experience
  workExp: {
    title: "Work Experience",
    totalExpYears: "Work Experience",
    noExp: "No work experience",
    companyName: "Company name",
    businessSector: "Business Sector",
    position: "Position",
    jobType: "Job Type",
    empType: "Employment Type",
    startDate: "Start date",
    endDate: "End date",
    Responsibilities: "Responsibilities",
    salary: "Salary (Bath)",
    currentJob: "Current Job",
  },

  // Training Experience
  trainExp: {
    title: "Training Experience",
    trainingName: "Training Name",
    organization: "Organization",
    certificateOwner: "Certificate Issuer",
    DateOfIssue: "Date of Issue",
  },

  // Skill
  skill: {
    title: "Skill",
  },
  // Language Skills
  langSkills: {
    title: "Language Skills",
    tableHead: {
      reading: "Reading",
      writing: "Writing",
      speaking: "Speaking",
      listening: "Listening",
    },

    testTitle: "Test result",
  },

  //Ability to operate a vehicle
  drivingSkill: {
    title: "Ability to operate a vehicle",
    subTitle: "Driving ability",
    car: "Car",
    motorcycle: "Motorcycle",
    other: "Other",
    ownVehicle: "Own personal vehicle",
  },

  //Projects, Portfolio, Awards, and Other Experiences
  project: {
    title: "Projects, Portfolio, Awards, and Other Experiences",
    participationDate: "Date Joined",
  },

  //button titles
  btn: {
    back: "Profile",
    downloadProfile: "Download Profile",
    printProfile: "Print Profile",
    manageBookConfirm: "Update",
    manageBookCancel: "Cancel",
  },

  question: {
    title: "Question",
    questionDetail: "Question to consult with the organization"
  },

  interviewType: {
    title: "Attendance Type",
    type: "Type",
    individual: "Individual",
    group: "Group",
    amount: "Number of people",
    unit: "person(s)",
  },
};
